import { memo } from 'react'
import { useField } from 'formik'
import noop from 'lodash/noop'

import Error from './error'
import Input, { InputProps } from './input'

interface Props extends InputProps {
  name: string
  hideError?: boolean
  hideErrorMessage?: boolean
}

const FieldInput: React.FC<Props> = ({
  name,
  hideError = false,
  hideErrorMessage = false,
  onBlur = noop,
  ...rest
}) => {
  const [field, meta] = useField(name)
  if (rest.type === 'checkbox') {
    field.checked = field.value
  }
  const hasError = !!meta.error && meta.touched && !hideError
  const { onBlur: formOnBlur, ...fields } = field
  return (
    <>
      <Input
        hasError={hasError}
        onBlur={e => {
          if (typeof onBlur === 'function') onBlur()
          formOnBlur(e)
        }}
        {...fields}
        {...rest}
      />
      {!hideError && !hideErrorMessage && <Error name={name} />}
    </>
  )
}

export default memo(FieldInput)
